'use client';
import 'react-photo-view/dist/react-photo-view.css';
import Image from 'next/image';

import {
  SliderMainItem,
  SliderThumbItem,
  CarouselNext,
  Carousel,
  CarouselMainContainer,
  CarouselThumbsContainer,
  CarouselPrevious,
  CarouselIndicator,
} from '@/components/extencions/carousel';
import { IMasterclass } from '@/entities/masterclass/types';
import { cn } from '@/shared/utils/utils';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import { LAZY_IMAGE_LOADING } from '@/shared/const/image-props';

export const MobileCarousel = ({
  images,
  height: _height = 450,
  mcName,
}: {
  mcName: string;
  images?: IMasterclass['images'];
  height?: number;
}) => {
  return (
    <>
      <Carousel className="rounded-3xl">
        <div className="hidden md:contents">
          <CarouselNext className="top-[42%] -translate-y-1/2" />
          <CarouselPrevious className="top-[42%] -translate-y-1/2" />
        </div>

        <div
          className={cn(
            'absolute z-20 bottom-[122px] left-1/2 -translate-x-1/2',
          )}
        >
          <CarouselThumbsContainer className="gap-x-1 overflow-hidden ">
            {images?.map((image, index) => (
              <CarouselIndicator key={index} index={index} />
            ))}
          </CarouselThumbsContainer>
        </div>
        <CarouselMainContainer className="rounded-3xl">
          <PhotoProvider>
            {images?.map((image, index) => (
              <SliderMainItem
                key={index}
                className="rounded-3xl bg-[#f7e6af]/30 overflow-hidden"
              >
                <PhotoView key={index} src={image.url}>
                  <Image
                    loading={LAZY_IMAGE_LOADING}
                    src={image.url}
                    alt={mcName}
                    className={cn(
                      'rounded-lg object-contain max-h-[350px] md:max-h-[500px]',
                    )}
                    width={1000}
                    height={1000}
                    quality={70}
                    sizes="(max-width: 768px) 100vw, 500px"
                  />
                </PhotoView>
              </SliderMainItem>
            ))}
          </PhotoProvider>
        </CarouselMainContainer>

        <CarouselThumbsContainer className="gap-3">
          {images?.map((image, index) => (
            <SliderThumbItem
              key={index}
              index={index}
              className="bg-transparent"
            >
              <Image
                loading={LAZY_IMAGE_LOADING}
                src={image.url}
                alt={mcName}
                className="rounded-lg object-cover"
                style={{ height: 'stretch'}}
                width={100}
                height={100}
              />
            </SliderThumbItem>
          ))}
        </CarouselThumbsContainer>
      </Carousel>
    </>
  );
};
